/*jshint esnext: false */

var AutocompleteService = (function(){
  'use strict';

  /****** variables paramètres globales ******/

  /* paramètres des éléments à utiliser pour l'autocomplétion */
  var G_CHAMP_SAISIE_ITIN_DEPART = 'ItinDepart';
  var G_BLOC_AUTOCOMPLETE_ITIN_DEPART = 'autoDepartSelect';

  var G_CHAMP_SAISIE_ITIN_ARRIVEE = 'ItinArrivee';
  var G_BLOC_AUTOCOMPLETE_ITIN_ARRIVEE = 'autoArriveeSelect';

  /* paramètres bounds définies pour GL */
  var G_GL_NW = {lng:4.53221, lat:45.99104};
  var G_GL_SW = {lng:4.53221, lat:45.54293};
  var G_GL_SE = {lng:5.16700, lat:45.54293};
  var G_GL_NE = {lng:5.16700, lat:45.99104};

  /***** variables globales *****/

  /* la valeur de la précédente recherche */
  var precedenteRecherche = null;

  /* paramètre si l'autocomplétion doit utiliser prédictions.description au lieu de place.formatted_address */
  var g_forcerPredictionDescription = true;

  /***** fonctions pour l'autocomplétion ******/

  function init(){}

  /* vérifie si le lat et la lng est dans les limites définies */
  function isInBounds(lat, lng) {
    var estBienDansBounds = false;

    if (( G_GL_NW.lat > lat && lat > G_GL_SW.lat ) && ( G_GL_NW.lng < lng && lng < G_GL_NE.lng)) {
      estBienDansBounds = true;
    }

    return estBienDansBounds;
  }

  /* reconnaître quel bloc autocomplétion à utiliser suivant le champ de saisie utilisé */
  function recupereBlocItin( champSaisi ) {
    var blocInit = null;

    if ( champSaisi === G_CHAMP_SAISIE_ITIN_DEPART ) {
      blocInit =  G_BLOC_AUTOCOMPLETE_ITIN_DEPART;
    } else if ( champSaisi === G_CHAMP_SAISIE_ITIN_ARRIVEE ) {
      blocInit = G_BLOC_AUTOCOMPLETE_ITIN_ARRIVEE;
    }

    return blocInit;
  }

  /* construire le corps principal du bloc autocomplétion */
  function construireCorpsBlocAutocompletion(blocInit) {
    var blocHTML = '<div id="autocompleteAdresses"></div>';
    $('#' + blocInit).append(blocHTML);
  }

  /* construire le bouton favoris, étoile bleue si non favoris, étoile jaune si favoris */
  function construireLienHTML(place, blocInit, adresseSansPays) {
    var optionsDivAutocompleteAdresse = 'data-type="autocomplete-address" ' +
    'data-latitude="' + place[1] + '" ' +
    'data-longitude="' + place[0] + '" ';

    var html = '' +
      '<li class="selectable"> ' +
        '<div ' + optionsDivAutocompleteAdresse + '>' +
          '<span>' + adresseSansPays + '</span>' +
        '</div>' +
      '</li>';

    var idBloc = '#' + blocInit + ' #autocompleteAdresses';
    $(idBloc).prepend(html);
  }

  /* construire le lien HTML avec le bouton favoris */
  function construireLienHTMLAutocomplete(place, blocInit, prediction) {
    var adresseSansPays = Geocoder.formatAddress(prediction.properties);
    construireLienHTML(place, blocInit, adresseSansPays);
  }

  /* construire lien html si la place obtenue est bien dans les périmètres définies
  car les prédictions google ne renvoie pas toujours les données dans les bounds définies */
  function lancerCreationLienHTMLAutocomplete(blocInit, prediction) {
    var place = prediction.geometry.coordinates;
    if ( isInBounds(place[1], place[0]) ) {
      construireLienHTMLAutocomplete(place, blocInit, prediction);
    }
  }

  /* invoque l'api google getDetails en utilisant la place_id  */
  function getDetail_photon_js(prediction, blocInit) {
    lancerCreationLienHTMLAutocomplete(blocInit, prediction);
  }

  /* nettoyer le bloc autocompletion */
  function nettoyerBlocAutoCompletion(autoSelect) {
    $('#' + autoSelect).removeClass( autoSelect + '-no-border');
    $('#' + autoSelect + ' #autocompleteAdresses').remove();
  }

  /* crée des liens prédictions obtenues dans un format adapté au design prévu */
  function creerLiensHTMLPredictions(predictions, champSaisi) {
    var blocInit = recupereBlocItin(champSaisi);
    construireCorpsBlocAutocompletion(blocInit);
    var streets = [];
    var prediction = null;
    for (var i = 0; i < predictions.features.length; i++) {
      prediction = predictions.features[i];
      if (!streets[Geocoder.formatAddress(prediction.properties)]) {
        streets[Geocoder.formatAddress(prediction.properties)] = 1;
        getDetail_photon_js(prediction, blocInit);
      }
    }
  }

  /* executer les démarches autocompletion */
  function executerAutocompletion(predictions, autoSelect, saisieItin) {
    nettoyerBlocAutoCompletion(autoSelect);
    creerLiensHTMLPredictions(predictions.data, saisieItin);
  }

  /* fonction provisoire, précise quelle affichage de l'autocomplétion à utiliser (prediction.decription ou place.formatted_address)
  selon la présence ou non du & dans le premier caractère de la recherche */
  function parametrerForcerPredictionDescription(recherche) {

    if (recherche.substr(0,1) === '&') {
      g_forcerPredictionDescription = false;
      recherche = recherche.substr(1);
    } else {
      g_forcerPredictionDescription = true;
    }

    return recherche;
  }

  /* fait appel à l'autocompletion google en utilisant les paramètres défines à dsn */
  function demarreProcedureAutocomplete(recherche, id_bloc, id_champ) {
    /* ligne mise en place provisoirement pour comparer la différence du choix d'affichage de l'autocomplétion */
    recherche = parametrerForcerPredictionDescription(recherche);

    Geocoder.geocode(recherche,function(predictions) {
      executerAutocompletion(predictions, id_bloc, id_champ);
    });
  }

  /* invoque l'api si la recherche est nouvelle et non vide */
  function autocomplete_photon_js(recherche, id_bloc, id_champ) {
    if (recherche !== '' && recherche !== precedenteRecherche) {
      precedenteRecherche = recherche;

      demarreProcedureAutocomplete(recherche, id_bloc, id_champ);
    }
  }

  /* invoque l'autocomplétion pour le champ départ */
  function send_autocompletion_depart_GMapJS(){
    var recherche = $('#' + G_CHAMP_SAISIE_ITIN_DEPART).val();
    autocomplete_photon_js(recherche, G_BLOC_AUTOCOMPLETE_ITIN_DEPART, G_CHAMP_SAISIE_ITIN_DEPART);
  }

  /* invoque l'autocomplétion pour le champ arrivee */
  function send_autocompletion_arrivee_GMapJS(){
    var recherche = $('#' + G_CHAMP_SAISIE_ITIN_ARRIVEE).val();
    autocomplete_photon_js(recherche, G_BLOC_AUTOCOMPLETE_ITIN_ARRIVEE, G_CHAMP_SAISIE_ITIN_ARRIVEE);
  }

  return {
    init: init,
    send_autocompletion_depart_GMapJS: send_autocompletion_depart_GMapJS,
    send_autocompletion_arrivee_GMapJS: send_autocompletion_arrivee_GMapJS
  };

}());
